module.exports = __webpack_public_path__ + "static/media/icono-idioma.83839610.svg";